import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';

/** @class PropertyCardFlexWrapperMixin */
/** @method */
export var PropertyCardFlexWrapperMixin = function PropertyCardFlexWrapperMixin(props) {
  return token('PropertyCard.flexArea.padding', function (padding) {
    return css(["padding:", ";"], padding ? padding + "px" : spaceMixin('xs')(props));
  })(props);
};